export default __webpack_public_path__ + "static/emailIcon-34365e46bc3d9f7737881b6b0966edf4.png";